import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHFuncionDel = async (credentials, data) => {
  const body = {
    service: "RNHFuncionDel",
    params: {
      rnhFuncionId: data?.id || null,
      rnhFuncionVersion: data?.version ?? null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
